(function () {
  "use strict";

  var drawer = document.querySelector("[data-cart-drawer]");
  var countEls = document.querySelectorAll("[data-cart-count]");
  var lineContainer = drawer ? drawer.querySelector("[data-cart-lines]") : null;
  var totalEl = drawer ? drawer.querySelector("[data-cart-total]") : null;
  var moneyFormatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: window.shopCurrency || "CAD"
  });

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[character];
    });
  }

  function formatMoney(cents) {
    return moneyFormatter.format(Number(cents || 0) / 100);
  }

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) {
      var closeButton = drawer.querySelector("[data-close-cart]");
      if (closeButton) closeButton.focus();
    }
  }

  function renderCart(cart) {
    countEls.forEach(function (element) { element.textContent = cart.item_count; });
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (!lineContainer) return;
    if (!cart.items.length) {
      lineContainer.innerHTML = '<p class="itj-cart-empty-copy">A journal for the journey ahead.</p>';
      return;
    }
    lineContainer.innerHTML = cart.items.map(function (item) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : "";
      return '<div class="itj-cart-line" data-cart-line data-line-key="' + escapeHtml(item.key) + '">' +
        '<div class="itj-cart-line-image">' + image + '</div>' +
        '<div><strong>' + escapeHtml(item.product_title) + '</strong>' +
        '<p>' + formatMoney(item.final_line_price) + '</p>' +
        '<div class="itj-quantity">' +
        '<button type="button" data-cart-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-cart-change data-line-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
        '</div></div></div>';
    }).join("");
  }

  function refreshCart() {
    return fetch(window.routes.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(renderCart);
  }

  var activeIntentionQuestion = "01";
  var intentionSelections = {};
  var intentionChoiceDetails = {
    "A new place": "A different horizon and a reason to look up from the familiar.",
    "A slower rhythm": "Fewer demands, softer mornings, and enough time to notice.",
    "Connection": "A shared table, a familiar place, or the chance to meet someone new.",
    "Something unknown": "A little edge, a new route, and a reason to stay curious.",
    "Rested": "A slower rhythm, fewer demands, and enough quiet to hear yourself think.",
    "Braver": "A little more courage in your step, and a story you could not have planned.",
    "Rooted": "More grounded in the people, places and moments that make the journey feel like yours.",
    "Changed": "A wider view, a different rhythm, and something useful to carry home.",
    "A slow morning": "Coffee, an open window, and nowhere you need to be quite yet.",
    "A change of pace": "A new rhythm, a little room to notice, and enough time to follow it.",
    "A shared table": "Good food, easy conversation, and someone to tell the story to.",
    "A new direction": "A turn you did not plan for, and enough time to follow it.",
    "Rushing": "Less racing the clock, more room for the details that make the day yours.",
    "Overplanning": "Fewer fixed points, more trust in what the day offers back.",
    "Collecting": "Fewer checkmarks, more attention to what stays with you.",
    "Crowds": "A quieter pace and space to hear what you need."
  };
  function updateIntentionDetail(option) {
    var detail = document.querySelector("[data-intention-detail]");
    if (detail) detail.textContent = intentionChoiceDetails[option] || "";
  }
  function renderIntentionOptions(questionButton) {
    var optionContainer = document.querySelector(".itj-intention-pills");
    if (!optionContainer) return;
    var options = (questionButton.dataset.intentionOptions || "").split("|").map(function (option) {
      return option.trim();
    }).filter(Boolean);
    var selected = intentionSelections[activeIntentionQuestion] || options[0] || "";
    intentionSelections[activeIntentionQuestion] = selected;
    updateIntentionDetail(selected);
    optionContainer.innerHTML = options.map(function (option) {
      return '<button type="button" data-intention-tag aria-pressed="' + (option === selected ? "true" : "false") + '">' + escapeHtml(option) + ' <span aria-hidden="true">→</span></button>';
    }).join("");
  }

  function updateInsideJournal(root, phaseId, requestedIndex, expandedPageId) {
    if (!root) return;
    root.dataset.activePhase = phaseId;
    root.querySelectorAll("[data-inside-chapter-card]").forEach(function (card) {
      var active = card.dataset.insideChapterCard === phaseId;
      card.classList.toggle("is-active", active);
      card.querySelectorAll("[data-inside-phase]").forEach(function (button) {
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
    root.querySelectorAll("[data-inside-summary]").forEach(function (summary) {
      summary.hidden = summary.dataset.insideSummary !== phaseId;
    });

    var pages = Array.prototype.slice.call(root.querySelectorAll("[data-inside-page]")).filter(function (page) {
      return page.dataset.pagePhase === phaseId;
    });
    var pageCount = pages.length;
    var currentIndex = pageCount ? Math.max(0, Math.min(pageCount - 1, Number(requestedIndex) || 0)) : 0;
    pages.forEach(function (page, index) {
      var active = index === currentIndex;
      page.hidden = !active;
      page.classList.toggle("is-active", active);
    });
    root.querySelectorAll("[data-inside-page][data-page-phase]").forEach(function (page) {
      if (page.dataset.pagePhase !== phaseId) {
        page.hidden = true;
        page.classList.remove("is-active");
      }
    });

    var activePage = pages[currentIndex];
    root.querySelectorAll("[data-inside-page-target]").forEach(function (button) {
      var selected = !!activePage && button.dataset.insidePageTarget === activePage.dataset.pageId;
      var expanded = selected && button.dataset.insidePageTarget === expandedPageId;
      button.classList.toggle("is-selected", selected);
      button.classList.toggle("is-open", expanded);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
      button.setAttribute("aria-expanded", expanded ? "true" : "false");
      var description = button.parentElement.querySelector(".itj-inside-chapter-page-description");
      if (description) description.hidden = !expanded;
    });
    var number = root.querySelector("[data-inside-page-number]");
    var total = root.querySelector("[data-inside-page-total]");
    var progress = root.querySelector("[data-inside-progress]");
    var empty = root.querySelector("[data-inside-empty]");
    var stepButtons = root.querySelectorAll("[data-inside-step]");
    if (number) number.textContent = String(pageCount ? currentIndex + 1 : 0).padStart(2, "0");
    if (total) total.textContent = String(pageCount).padStart(2, "0");
    if (progress) progress.style.width = (pageCount ? (currentIndex + 1) / pageCount * 100 : 0) + "%";
    if (empty) empty.hidden = pageCount > 0;
    stepButtons.forEach(function (button) {
      var direction = Number(button.dataset.insideStep);
      button.disabled = pageCount < 2 || (direction < 0 && currentIndex === 0) || (direction > 0 && currentIndex === pageCount - 1);
    });
  }

  function stepInsideJournal(root, delta) {
    if (!root) return;
    var phaseId = root.dataset.activePhase || "before";
    var phasePages = Array.prototype.slice.call(root.querySelectorAll("[data-inside-page]")).filter(function (page) {
      return page.dataset.pagePhase === phaseId;
    });
    var activePageIndex = phasePages.findIndex(function (page) { return page.classList.contains("is-active"); });
    var nextIndex = phasePages.length ? Math.max(0, Math.min(phasePages.length - 1, activePageIndex + delta)) : 0;
    updateInsideJournal(root, phaseId, nextIndex);
  }

  function initializeInsideJournals(root) {
    (root || document).querySelectorAll("[data-inside-journal]").forEach(function (section) {
      updateInsideJournal(section, section.dataset.activePhase || "before", 0);
      if (section.dataset.journalEventsReady === "true") return;
      section.dataset.journalEventsReady = "true";
      var touchStartX = null;
      section.addEventListener("touchstart", function (event) {
        touchStartX = event.changedTouches.length ? event.changedTouches[0].clientX : null;
      }, { passive: true });
      section.addEventListener("touchend", function (event) {
        if (touchStartX === null || !event.changedTouches.length) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) > 45) stepInsideJournal(section, distance < 0 ? 1 : -1);
        touchStartX = null;
      }, { passive: true });
      section.addEventListener("keydown", function (event) {
        if (!event.target.closest("[data-inside-slides]")) return;
        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault();
          stepInsideJournal(section, event.key === "ArrowRight" ? 1 : -1);
        }
      });
    });
  }

  var readerCards = document.querySelectorAll("[data-reader-quote]");
  var readerIndex = 0;
  function updateReaderNotes() {
    if (!readerCards.length) return;
    readerCards.forEach(function (card, index) {
      var offset = (index - readerIndex + readerCards.length) % readerCards.length;
      card.classList.toggle("is-featured", offset === 0);
      card.style.order = offset === 0 ? "2" : offset === 1 ? "1" : "3";
    });
    var count = document.querySelector("[data-reader-count]");
    if (count) count.textContent = String(readerIndex + 1).padStart(2, "0") + " / " + String(readerCards.length).padStart(2, "0");
  }

  document.addEventListener("click", function (event) {
    var galleryThumbnail = event.target.closest("[data-product-gallery-thumb]");
    if (galleryThumbnail) {
      var gallery = galleryThumbnail.closest("[data-product-gallery]");
      if (gallery) {
        var galleryIndex = galleryThumbnail.dataset.galleryIndex;
        gallery.querySelectorAll("[data-product-gallery-item]").forEach(function (item) {
          var active = item.dataset.galleryIndex === galleryIndex;
          item.hidden = !active;
          item.classList.toggle("is-active", active);
        });
        gallery.querySelectorAll("[data-product-gallery-thumb]").forEach(function (button) {
          var active = button === galleryThumbnail;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
      }
    }
    var insidePageButton = event.target.closest("[data-inside-page-target]");
    if (insidePageButton) {
      var pageSection = insidePageButton.closest("[data-inside-journal]");
      if (pageSection) {
        var pagePhase = insidePageButton.dataset.insidePagePhase;
        var phasePages = Array.prototype.slice.call(pageSection.querySelectorAll("[data-inside-page]")).filter(function (page) {
          return page.dataset.pagePhase === pagePhase;
        });
        var targetIndex = phasePages.findIndex(function (page) {
          return page.dataset.pageId === insidePageButton.dataset.insidePageTarget;
        });
        if (targetIndex >= 0) {
          var expandedId = insidePageButton.getAttribute("aria-expanded") === "true" ? null : insidePageButton.dataset.insidePageTarget;
          updateInsideJournal(pageSection, pagePhase, targetIndex, expandedId);
        }
      }
    }
    var insidePhaseButton = event.target.closest("[data-inside-phase]");
    if (insidePhaseButton) {
      var insideSection = insidePhaseButton.closest("[data-inside-journal]");
      if (insideSection) updateInsideJournal(insideSection, insidePhaseButton.dataset.insidePhase, 0);
    }
    var insideStepButton = event.target.closest("[data-inside-step]");
    if (insideStepButton) {
      var stepSection = insideStepButton.closest("[data-inside-journal]");
      if (stepSection) stepInsideJournal(stepSection, Number(insideStepButton.dataset.insideStep) || 0);
    }
    var openButton = event.target.closest("[data-open-cart]");
    var closeButton = event.target.closest("[data-close-cart]");
    var changeButton = event.target.closest("[data-cart-change]");
    if (openButton) { event.preventDefault(); setDrawer(true); refreshCart(); }
    if (closeButton) { event.preventDefault(); setDrawer(false); }
    if (changeButton) {
      event.preventDefault();
      fetch(window.routes.cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: changeButton.dataset.lineKey, quantity: Number(changeButton.dataset.quantity) })
      }).then(function (response) { return response.json(); }).then(renderCart);
    }
    var tab = event.target.closest("[data-chapter-tab]");
    if (tab) {
      var targetId = tab.dataset.chapterTab;
      var chapterSection = tab.closest(".itj-chapters");
      var chapterTabs = chapterSection ? Array.prototype.slice.call(chapterSection.querySelectorAll("[data-chapter-tab]")) : [];
      chapterTabs.forEach(function (button) {
        var active = button === tab;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });
      if (chapterSection) chapterSection.querySelectorAll("[data-chapter-panel]").forEach(function (panel) {
        var active = panel.dataset.chapterPanel === targetId;
        panel.hidden = !active;
        panel.classList.toggle("is-hidden", !active);
        panel.querySelectorAll("video").forEach(function (video) {
          if (active && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      });
      var chapterIndex = chapterTabs.indexOf(tab);
      var chapterCount = chapterSection && chapterSection.querySelector("[data-chapter-count]");
      var chapterProgress = chapterSection && chapterSection.querySelector("[data-chapter-progress]");
      if (chapterCount) chapterCount.textContent = String(chapterIndex + 1).padStart(2, "0") + " / " + String(chapterTabs.length).padStart(2, "0");
      if (chapterProgress) chapterProgress.style.width = (chapterTabs.length ? (chapterIndex + 1) / chapterTabs.length * 100 : 0) + "%";
    }
    var journeyLink = event.target.closest("[data-journey-target-phase]");
    if (journeyLink) {
      var journal = document.querySelector("[data-inside-journal]");
      if (journal) {
        var targetPhase = journeyLink.dataset.journeyTargetPhase;
        var matchingPages = Array.prototype.slice.call(journal.querySelectorAll("[data-inside-page]")).filter(function (page) {
          return page.dataset.pagePhase === targetPhase;
        });
        var selectedIndex = matchingPages.findIndex(function (page) {
          return page.dataset.title === journeyLink.dataset.journeyTargetPage;
        });
        updateInsideJournal(journal, targetPhase, Math.max(0, selectedIndex));
      }
    }
    var pageTab = event.target.closest("[data-page-tab]");
    if (pageTab) {
      var pageId = pageTab.dataset.pageTab;
      document.querySelectorAll("[data-page-tab]").forEach(function (button) {
        var active = button === pageTab;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });
      document.querySelectorAll("[data-page-panel], [data-page-copy]").forEach(function (panel) {
        panel.hidden = panel.dataset.pagePanel !== pageId && panel.dataset.pageCopy !== pageId;
      });
    }
    var activityTab = event.target.closest("[data-activity-tab]");
    if (activityTab) {
      var activityId = activityTab.dataset.activityTab;
      document.querySelectorAll("[data-activity-tab]").forEach(function (button) {
        var active = button === activityTab;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", active ? "true" : "false");
      });
      document.querySelectorAll("[data-activity-panel]").forEach(function (panel) {
        panel.hidden = panel.dataset.activityPanel !== activityId;
      });
    }
    var idea = event.target.closest("[data-idea]");
    if (idea) {
      var pressed = idea.getAttribute("aria-pressed") === "true";
      idea.setAttribute("aria-pressed", pressed ? "false" : "true");
      var mark = idea.querySelector(".itj-idea-mark");
      if (mark) mark.textContent = pressed ? "+" : "✓";
      var selected = document.querySelectorAll("[data-idea][aria-pressed=\"true\"]").length;
      var count = document.querySelector("[data-idea-count]");
      if (count) count.textContent = selected + (selected === 1 ? " feeling" : " feelings") + " held for this journey";
    }
    var intentionQuestion = event.target.closest("[data-intention-question]");
    if (intentionQuestion) {
      document.querySelectorAll("[data-intention-question]").forEach(function (button) {
        var active = button === intentionQuestion;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });
      var questionNumber = intentionQuestion.querySelector("span");
      var intentionMark = document.querySelector("[data-intention-mark]");
      if (questionNumber) activeIntentionQuestion = questionNumber.textContent;
      if (questionNumber && intentionMark) intentionMark.textContent = questionNumber.textContent + " / SELECT ONE";
      var intentionAnswer = document.querySelector("[data-intention-answer]");
      var nextAnswer = intentionQuestion.dataset.intentionAnswerCopy;
      if (intentionAnswer && nextAnswer) intentionAnswer.textContent = nextAnswer;
      renderIntentionOptions(intentionQuestion);
    }
    var intentionTag = event.target.closest("[data-intention-tag]");
    if (intentionTag) {
      var selectedOption = intentionTag.textContent.replace("→", "").trim();
      intentionSelections[activeIntentionQuestion] = selectedOption;
      updateIntentionDetail(selectedOption);
      document.querySelectorAll("[data-intention-tag]").forEach(function (button) {
        button.setAttribute("aria-pressed", button === intentionTag ? "true" : "false");
      });
    }
    var readerPrevious = event.target.closest("[data-reader-prev]");
    var readerNext = event.target.closest("[data-reader-next]");
    if (readerPrevious && readerCards.length) {
      readerIndex = (readerIndex - 1 + readerCards.length) % readerCards.length;
      updateReaderNotes();
    }
    if (readerNext && readerCards.length) {
      readerIndex = (readerIndex + 1) % readerCards.length;
      updateReaderNotes();
    }
  });

  document.querySelectorAll("form.itj-product-form").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var button = form.querySelector("button[type=\"submit\"]");
      if (button) button.disabled = true;
      fetch(window.routes.cartAdd + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to add this product.");
          return response.json();
        })
        .then(function () { return refreshCart(); })
        .then(function () { setDrawer(true); })
        .catch(function (error) { window.alert(error.message); })
        .finally(function () { if (button) button.disabled = false; });
    });
  });

  document.addEventListener("change", function (event) {
    var variantSelect = event.target.closest("[data-product-variant-select]");
    if (!variantSelect) return;
    var variant = variantSelect.options[variantSelect.selectedIndex];
    if (!variant) return;
    var productSection = variantSelect.closest(".itj-buy, .itj-product-page");
    if (!productSection) return;
    var price = productSection.querySelector("[data-product-price]");
    if (price && variant.dataset.priceCents) {
      price.textContent = moneyFormatter.format(Number(variant.dataset.priceCents) / 100);
    }
    var submit = productSection.querySelector("form.itj-product-form button[type=\"submit\"]");
    if (submit) submit.disabled = variant.disabled;
  });

  var menuButton = document.querySelector("[data-menu-toggle]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  if (menuButton && mobileNav) {
    menuButton.addEventListener("click", function () {
      var open = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", open ? "false" : "true");
      mobileNav.hidden = open;
      var label = menuButton.querySelector(".visually-hidden");
      if (label) label.textContent = open ? "Open navigation" : "Close navigation";
    });
    mobileNav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        menuButton.setAttribute("aria-expanded", "false");
        mobileNav.hidden = true;
      });
    });
  }

  function initializeArrivalTypewriter(root) {
    var arrival = (root || document).querySelector("[data-arrival-word]");
    if (!arrival || arrival.dataset.typewriterReady === "true") return;

    var words = (arrival.dataset.words || "arrival|the first solo dinner|doing something difficult|finding your way|the view you didn't expect|coming home changed")
      .split("|")
      .map(function (word) { return word.trim(); })
      .filter(Boolean);
    if (!words.length) return;

    arrival.dataset.typewriterReady = "true";

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      arrival.textContent = words[0];
      return;
    }

    var wordIndex = 0;
    var characterIndex = 0;
    var deleting = false;
    var timer;

    function typeNextCharacter() {
      var word = words[wordIndex];

      if (!deleting) {
        characterIndex += 1;
        arrival.textContent = word.slice(0, characterIndex);
        if (characterIndex === word.length) {
          deleting = true;
          timer = window.setTimeout(typeNextCharacter, 1800);
          return;
        }
        timer = window.setTimeout(typeNextCharacter, 70);
        return;
      }

      characterIndex -= 1;
      arrival.textContent = word.slice(0, characterIndex);
      if (characterIndex === 0) {
        deleting = false;
        wordIndex = (wordIndex + 1) % words.length;
        timer = window.setTimeout(typeNextCharacter, 350);
        return;
      }
      timer = window.setTimeout(typeNextCharacter, 35);
    }

    function startTypewriter() {
      if (timer) return;
      arrival.textContent = "";
      timer = window.setTimeout(typeNextCharacter, 300);
    }

    var section = arrival.closest(".itj-arrival");
    if ("IntersectionObserver" in window && section) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          startTypewriter();
        }
      }, { threshold: 0.25 });
      observer.observe(section);
    } else {
      startTypewriter();
    }
  }

  initializeInsideJournals(document);
  initializeArrivalTypewriter(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeInsideJournals(event.target);
    initializeArrivalTypewriter(event.target);
  });
  document.addEventListener("shopify:block:select", function (event) {
    var chapterTab = event.target.closest("[data-chapter-tab]");
    if (chapterTab) {
      chapterTab.click();
      return;
    }
    var block = event.target.closest("[data-inside-page], [data-inside-chapter-card]");
    if (!block) return;
    var section = block.closest("[data-inside-journal]");
    if (!section) return;
    if (block.hasAttribute("data-inside-chapter-card")) {
      updateInsideJournal(section, block.dataset.insideChapterCard, 0);
      return;
    }
    var phase = block.dataset.pagePhase;
    var pages = Array.prototype.slice.call(section.querySelectorAll("[data-inside-page]")).filter(function (page) {
      return page.dataset.pagePhase === phase;
    });
    var index = pages.indexOf(block);
    if (index >= 0) updateInsideJournal(section, phase, index);
  });

  updateReaderNotes();
})();

/* Mobile: keep the current page preview with its selected chapter, not below all four. */
(function () {
  var mobile = window.matchMedia("(max-width: 760px)");

  function placePreview(section) {
    if (!section) return;
    var preview = section.querySelector(".itj-inside-feature");
    var layout = section.querySelector(".itj-inside-journal-layout");
    var activeChapter = section.querySelector("[data-inside-chapter-card].is-active");
    if (!preview || !layout) return;
    if (mobile.matches && activeChapter) {
      if (activeChapter.nextElementSibling !== preview) activeChapter.insertAdjacentElement("afterend", preview);
    } else if (preview.parentElement !== layout) {
      layout.appendChild(preview);
    }
  }

  function placeAllPreviews() {
    document.querySelectorAll("[data-inside-journal]").forEach(placePreview);
  }

  placeAllPreviews();
  mobile.addEventListener("change", placeAllPreviews);
  document.addEventListener("shopify:section:load", placeAllPreviews);
  document.addEventListener("click", function (event) {
    var chapter = event.target.closest("[data-inside-phase]");
    var page = event.target.closest("[data-inside-page-target]");
    if (!chapter && !page) return;
    var section = (chapter || page).closest("[data-inside-journal]");
    placePreview(section);
    if (page && mobile.matches) {
      var preview = section && section.querySelector(".itj-inside-feature");
      if (preview) window.requestAnimationFrame(function () {
        preview.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
          block: "start"
        });
      });
    }
  });
})();